export default "__VITE_ASSET__DfKElziF__$_?url__"